import React, { useEffect, useRef, useState } from "react";
import Papa from "papaparse";
import { Modal } from "react-bootstrap";
import { Checkbox, Button } from "@mui/material";
import { uploadCSV } from "../../utils/api-Request";
import FullScreenLoader from "../common/FullScreenLoader";
import { Debounce } from "../common/Debounce";

const defaultCSVTitleValues = ["Name", "URL", "Industry", "industry", "Technology", "Product", "Use Case", "Client"];

const CSVUpload = () => {
  const fileInputRef = useRef(null);
  const [csvData, setCsvData] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [validationModal, setValidationModal] = useState(false);
  const [uploadResponse, setUploadResponse] = useState([]);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const filterHeaders = results.meta.fields.filter((e) => defaultCSVTitleValues.includes(e));
        const filteredData = results.data
          .filter((row) => row.Name && row.URL)
          .map((row) => {
            const filteredRow = {};
            defaultCSVTitleValues.forEach((field) => {
              filteredRow[field] = row[field] || "";
            });
            return filteredRow;
          });
        setCsvData(filteredData);
        setSelectedFields(filterHeaders);
        setSelectedRows(filteredData.map((e, i) => i));
      },
    });
  };

  const handleRowToggle = (index) => {
    if (selectedRows.includes(index)) {
      setSelectedRows(selectedRows.filter((i) => i !== index));
    } else {
      setSelectedRows([...selectedRows, index]);
    }
  };

  const handleSelectAllToggle = () => {
    if (selectedRows.length === csvData.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(csvData.map((_, index) => index));
    }
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const payload = csvData.filter((_, i) => selectedRows.includes(i));
      if (!payload.length) return;
      const response = await uploadCSV(payload);
      setUploadResponse(response.data.data);
      setValidationModal(true);
      setCsvData([]);
      fileInputRef.current.value = "";
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const debounceSave = Debounce(handleSave, 500);

  return (
    <>
      <div className="uploaddatacsv p-4 max-w-3xl mx-auto ">
        <h2 className="text-xl font-semibold mb-4">Upload CSV</h2>

        <input ref={fileInputRef} type="file" accept=".csv" onChange={handleFileUpload} className="mb-4" />

        {csvData.length > 0 && selectedFields.length > 0 && (
          <div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <Button variant="contained" color="primary" size="small" onClick={handleSelectAllToggle}>
                  {selectedRows.length === csvData.length ? "Unselect All" : "Select All"}
                </Button>
              </div>
              <div>
                {loading ? (
                  <FullScreenLoader loading={loading} message="Uploading CSV" />
                ) : (
                  <Button
                    className="border m-2 mb-3"
                    variant="contained"
                    color="primary"
                    size="medium"
                    onClick={debounceSave}
                  >
                    Upload CSV
                  </Button>
                )}
              </div>
            </div>

            <div className="overflow-auto border rounded">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr>
                    <th className="border p-2">S.No</th>
                    <th className="border p-2">Select</th>
                    {selectedFields.map((field) => (
                      <th key={field} className="border p-2 bg-gray-100">
                        {field}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {csvData.map((row, i) => (
                    <tr key={i}>
                      <td className="border p-4">{i + 1}</td>
                      <td className="border p-2">
                        <Checkbox checked={selectedRows.includes(i)} onChange={() => handleRowToggle(i)} />
                      </td>
                      {selectedFields.map((field) => (
                        <td key={field} className="border p-2">
                          {row[field]}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      <Modal show={validationModal} centered size="xl" className="csvupload">
        <div className="modal-header">
          Uploaded Links
          <span style={{ cursor: "pointer" }} className="close-btn" onClick={() => setValidationModal(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-x"
              viewBox="0 0 16 16"
            >
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
            </svg>
          </span>
        </div>

        <div className="modal-body">
          <div className="count-here" style={{ display: "flex", justifyContent: "space-between" }}>
            <p>
              Uploaded CSV's : <span> {uploadResponse?.total_success_entries} </span>
            </p>
            <p>
              Duplicate CSV's : <span> {uploadResponse?.total_duplicate_entries} </span>
            </p>
          </div>
          {uploadResponse?.duplicate_entries?.length ? (
            <>
              <h4>Duplicate Entries</h4>
              <div className="role-table">
                <div className="sim-table table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Name</th>
                        <th>URL</th>
                        <th>Industry</th>
                        <th>Technology</th>
                        <th>Product</th>
                        <th>Use Case</th>
                        <th>Client</th>
                      </tr>
                    </thead>
                    <tbody>
                      {uploadResponse?.duplicate_entries?.map((entry, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{entry.Name?.length > 20 ? `${entry?.Name.slice(0, 20)}...` : entry?.Name}</td>
                          <td>{entry?.URL}</td>
                          <td>{entry.Industry }</td>
                          <td>{entry.Technology}</td>
                          <td>{entry.Product}</td>
                          <td>{entry["Use Case"]}</td>
                          <td>{entry.Client}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          ) : (
            <h4 style={{ textAlign: "center" }}>CSV Uploaded</h4>
          )}
        </div>

        <div className="modal-footer">
          <span style={{ cursor: "pointer" }} className="close" onClick={() => setValidationModal(false)}>
            Close
          </span>
        </div>
      </Modal>
    </>
  );
};

export default CSVUpload;
